// src/services/visitReports.service.js
import api from './api';

const visitReportsService = {
  // Get summary data (employee table + chart data)
  getSummary: async (filters = {}) => {
    try {
      const response = await api.get('/reports/visits/summary', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Error fetching visit summary:', error);
      throw error;
    }
  },

  // Get paginated farmer visits detail
  getFarmerVisits: async (filters = {}, page = 1, limit = 20) => {
    try {
      const response = await api.get('/reports/visits/farmer-visits', {
        params: { ...filters, page, limit },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching farmer visits:', error);
      throw error;
    }
  },

  // Get paginated dealer visits detail
  getDealerVisits: async (filters = {}, page = 1, limit = 20) => {
    try {
      const response = await api.get('/reports/visits/dealer-visits', {
        params: { ...filters, page, limit },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching dealer visits:', error);
      throw error;
    }
  },

  // Export as Excel — returns blob
  exportExcel: async (filters = {}) => {
    try {
      const response = await api.get('/reports/visits/export', {
        params: filters,
        responseType: 'blob',
      });
      return response.data; // Blob
    } catch (error) {
      console.error('Error exporting visits:', error);
      throw error;
    }
  },
};

export default visitReportsService;